<template>
  <section class="ya-te-bg-gray">
    <div class="co-container-md mx-auto px-4 py-20">
      <div class="flex items-start justify-center">
        <img
          src="~/assets/images/YaTe/YaTeCounseling/subtitle-decoration.svg"
          alt=""
          width="14"
          height="15"
          loading="lazy"
        >
        <div class="co-display-11 ya-te-text-red mb-2 px-2 font-bold leading-normal">
          未経験でも安心のカリキュラム
        </div>
        <img
          src="~/assets/images/YaTe/YaTeCounseling/subtitle-decoration.svg"
          alt=""
          style="transform: scale(-1, 1)"
          width="14"
          height="15"
          loading="lazy"
        >
      </div>
      <h2 class="ya-te-page-title ya-te-text-primary mb-6 text-center font-extrabold">
        LINEヤフーが持つ<br class="hidden md:block">実践的な<br class="md:hidden">技術力を身につけられる
      </h2>
      <p class="mb-12 text-center">
        LINEヤフーのエンジニア育成を担う社員が監修したカリキュラムで学ぶことが可能です。<br class="hidden md:block">Webアプリケーション開発の業務に必要な基礎スキルを幅広く習得いただけます。
      </p>
      <div class="mb-12 flex flex-col gap-8 md:mb-16 md:flex-row md:gap-8">
        <div class="w-full rounded bg-white p-5 text-center md:w-1/3">
          <img
            class="mx-auto mb-4"
            src="~/assets/images/YaTe/YaTeCounseling/Curriculum/curriculum-image-1.svg"
            alt="プログラミングの技術を習得"
            width="300"
            height="161"
            loading="lazy"
          >
          <h3 class="ya-te-text-primary co-display-11 mb-2 font-extrabold leading-normal">
            プログラミングの技術を習得
          </h3>
          <p class="co-display-13">
            基礎から応用まで幅広く学び
            <br>
            実践的に経験を積むことができる。
          </p>
        </div>
        <div class="w-full rounded bg-white p-5 text-center md:w-1/3">
          <img
            class="mx-auto mb-4"
            src="~/assets/images/YaTe/YaTeCounseling/Curriculum/curriculum-image-2.jpg"
            alt="現場で必要な基礎知識を学習"
            width="300"
            height="161"
            loading="lazy"
          >
          <h3 class="ya-te-h3 ya-te-text-primary co-display-11 mb-2 font-extrabold leading-normal">
            現場で必要な基礎知識を学習
          </h3>
          <p class="co-display-13">
            システム開発の流れを理解し
            <br>
            チームで開発するための知識が身につく。
          </p>
        </div>
        <div class="w-full rounded bg-white p-5 text-center md:w-1/3">
          <img
            class="mx-auto mb-4"
            src="~/assets/images/YaTe/YaTeCounseling/Curriculum/curriculum-image-3.jpg"
            alt="本格的なWebアプリを開発"
            width="300"
            height="161"
            loading="lazy"
          >
          <h3 class="ya-te-h3 ya-te-text-primary co-display-11 mb-2 font-extrabold leading-normal">
            本格的なWebアプリを開発
          </h3>
          <p class="co-display-13">
            <slot name="text3">
              Webアプリケーションの仕組みを理解し
              <br>
              実際に開発してWeb上にリリースする。
            </slot>
          </p>
        </div>
      </div>

      <!-- LINEヤフーの現役社員がノウハウを伝授 -->
      <div class="co-container-sm mx-auto flex flex-col items-center gap-4 md:flex-row md:gap-8 md:px-4">
        <div class="md:w-7/12">
          <h3 class="ya-te-h3 ya-te-text-primary co-display-10 mb-3 font-extrabold leading-normal">
            LINEヤフーの現役社員がノウハウを伝授
          </h3>
          <p class="co-display-13">
            LINEヤフーの現役社員による講演動画と解説動画をご用意。<br class="hidden md:block">日本最大級のWebサービス企業で働くプロフェッショナルから、業界のリアルな話や現場での取り組みなどを聞くことができます。
          </p>
        </div>
        <div class="md:w-5/12">
          <img
            class="mx-auto"
            src="~/assets/images/YaTe/YaTeCounseling/Curriculum/event-image.jpg"
            alt="LINEヤフーの現役社員がノウハウを伝授"
            width="343"
            height="165"
            loading="lazy"
          >
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>
@import url("~/assets/css/YaTe/YaTeCommon/YaTeCommon.css");
</style>
